module.exports = __webpack_public_path__ + "static/img/shopcode2.418bae6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shopcode2.png
// module id = SXbI
// module chunks = 1